import { Button, Menu, MenuItem, Tooltip } from '@mui/material';
import { PDFDownloadLink } from '@react-pdf/renderer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../../reduxService/hooks';
import PDF from '../../../PDF/PDF';
import PDFMacro1 from '../../../PDF/PDFMacro1/PDFMacro1';
import { getActionByProjectType } from '../../../../actionMap';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import '../../../../style/mui.scss';
import { IDownloadButtonProps } from './IExportButton';
import { IInitialState, RootState } from '../../../../../reduxService';
import { IProjectMacro1 } from '../../../../Macro1/store/project/projectslice';
import { IProjectMacro2 } from '../../../../Macro2/store/project/projectslice';
//import { Pdf } from './pdfjs';

import { EProjectType } from '../../../../enum/project';
//import PDFMacro2 from '../../../PDF/PDFMacro1/PDFMacro1';
import { useSelector } from 'react-redux';

const DownloadButton = (props: IDownloadButtonProps) => {
    const { t, i18n } = useTranslation();

    const macro1Project = useSelector((state: RootState) => state.Macro1.project);
    const macro2Project = useSelector((state: RootState) => state.Macro2.project);
    const projectInfo = useAppSelector(selectProjectInfo);
    const macro1ResultsData = useSelector((state: RootState): any => state.Macro1.results.data?.outputData);
    const macro2ResultsData = useSelector((state: RootState): any => state.Macro2.results.data?.outputData);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [pdfUrl, setPdfUrl] = React.useState<string>('');
    const [imgs, setImgs] = React.useState<string[]>([]);
    const [refresh, setRefresh] = React.useState<boolean>(false);
    const { /* selectResults, selectProject, */ inputForm, graphic, results } = getActionByProjectType(projectInfo.data?.projectType);

    const open = Boolean(anchorEl);

    const handleExport = (e: React.MouseEvent<HTMLButtonElement>) => {
        pdfUrl && window.open(pdfUrl);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    React.useEffect(() => {
        setRefresh(true);
        setTimeout(() => {
            setRefresh(false);
        }, 1000);
    }, [i18n.language]);

    return (
        <>
            {projectInfo.data && (
                <PDFDownloadLink
                    className={'MuiMenuItem-root'}
                    document={
                          refresh ? <></> : (projectInfo.data?.projectType === EProjectType.Macro1 ? (
                                <PDFMacro1
                                    project={macro1Project.data! as IProjectMacro1}
                                    projectInfo={projectInfo.data!}
                                    results={macro1ResultsData}
                                />
                            ) : <PDF project={macro2Project.data! as IProjectMacro2} projectInfo={projectInfo.data!} results={macro2ResultsData} /> )
                    }
                    fileName={projectInfo.data?.projectName}>
                    {({ url, loading }) => {
                        React.useEffect(() => {
                            if (url && !pdfUrl) {
                                setPdfUrl(url);
                            }
                        }, [url]);

                        return loading || refresh ? (
                            <button type='button' className={props.className} disabled>
                                <i className='fa-solid fa-download' />
                                {t('header_export_button_pdf_downloading')}
                            </button>
                        ) : (
                            <button type='button' className={props.className}>
                                <i className='fa-solid fa-download' />
                                {t('header_export_button')}
                            </button>
                        );
                    }}
                </PDFDownloadLink>
            )}
        </>
    );
};

export default DownloadButton;
